import { createTheme, responsiveFontSizes } from "@mui/material";

let theme = createTheme({
  palette: {
    primary: {
      main: "#3f51b5",
    },
    secondary: {
      main: "#f50057",
    },
  },

  direction: "ltr",

  components: {
    MuiButton: {
      styleOverrides: {
        outlined: {
          backgroundColor: "#fff",
          ":hover": {
            backgroundColor: "#aaa",
            borderColor: "#999",
          },
          borderColor: "#aaa",
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        item: {
          paddingTop: 0,
          paddingLeft: 0,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h3: {
          "@media (min-width:120px)": {
            fontSize: 14,
            fontWeight: "bold",
          },
          "@media (min-width:300px)": {
            fontSize: 18,
            fontWeight: "bold",
          },

          "@media (min-width:400px)": {
            fontSize: 22,
            fontWeight: "bold",
          },
          "@media (min-width:600px)": {
            fontSize: 30,
          },
          "@media (min-width:800px)": {
            fontSize: 24,
          },
          "@media (min-width:1000px)": {
            fontSize: 24,
          },
          "@media (min-width:1280px)": {
            fontSize: 24,
          },
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme, {
  breakpoints: ["xs", "sm", "md", "lg", "xl"],
});

export default theme;
